import styled from '@emotion/styled';
import { colors, fonts, layout, DESKTOP } from '../tokens';

export const ShelfIntro = styled.p`
  font-family: ${fonts.body};
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.muted};
  margin: 0;
`;

export const GroupHeading = styled.p`
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.72px;
  text-transform: uppercase;
  color: ${colors.text};
  margin: 16px 0 0;
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const OptionRow = styled.div`
  display: flex;
  font-family: ${fonts.body};
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid ${colors.chipBorder};
  opacity: ${props => (props.disabled ? 0.6 : 1)};

  &:last-child {
    border-bottom: none;
  }
`;

export const OptionNameButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  font-weight: 500;
  font-size: 14px;
  color: ${colors.brand};
`;

export const OptionNameText = styled.span`
  font-family: ${fonts.body};
  font-weight: 500;
  font-size: 14px;
  color: ${props => (props.disabled ? colors.muted : colors.text)};
`;

export const OptionRight = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  width: 45%;
  justify-content: space-between;
`;

export const OptionPrice = styled.span`
  font-family: ${fonts.body};
  font-weight: 500;
  font-size: 14px;
  color: ${colors.text};
  white-space: nowrap;
`;

export const OptionPriceStruck = styled.span`
  font-family: ${fonts.body};
  font-weight: 500;
  font-size: 14px;
  color: ${colors.muted};
  text-decoration: line-through;
  white-space: nowrap;
`;

export const IncludedLabel = styled.span`
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 13px;
  color: ${colors.success};
  white-space: nowrap;
`;

export const IneligibleReason = styled.span`
  font-family: ${fonts.body};
  font-weight: 400;
  font-size: 13px;
  color: ${colors.muted};
  // white-space: nowrap;
`;

export const CheckboxButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Stepper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StepperButton = styled.button`
  appearance: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1.5px solid ${props => (props.disabled ? colors.disabled : colors.brand)};
  background: #fff;
  color: ${props => (props.disabled ? colors.disabled : colors.brand)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`;

export const StepperValue = styled.span`
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 14px;
  color: ${colors.text};
  min-width: 16px;
  text-align: center;
`;

/* ── Product detail modal ────────────────────────────────────────────────── */

export const DetailImage = styled.img`
  width: 100%;
  border-radius: 10px;
  display: block;
  max-width: 352px;
  ${DESKTOP} {
    max-width: ${layout.purchaseDetailImageWidth}px;
    margin: 0 auto;
  }
`;

export const DetailTagline = styled.p`
  font-family: ${fonts.body};
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.text};
  margin: 16px 0 0;
  white-space: break-spaces;
`;

export const DetailBody = styled.p`
  font-family: ${fonts.body};
  font-weight: 400;
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.muted};
  margin: 8px 0 0;
`;

/* ── Processing / status screens ─────────────────────────────────────────── */

export const StatusWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
  padding: 60px 20px;
  width: 100%;
`;

export const StatusHeading = styled.h2`
  font-family: ${fonts.heading};
  font-weight: 400;
  font-size: 24px;
  color: ${colors.heading};
  margin: 10px 0;
`;

export const StatusCopy = styled.p`
  font-family: ${fonts.body};
  font-weight: 400;
  font-size: 14px;
  color: ${colors.muted};
  margin: 10;
  max-width: 320px;
`;

export const StatusActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  width: 100%;
  max-width: 280px;
`;
